import React, { FC } from 'react';

import { Popover, Button, Stack } from '@mui/material';

import { IconButton } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export interface CustomPopoverProps {
    openPopOverLabel: string;
    options: CustomPopoverItemProps[];
    selectedOption: string | undefined;
    setSelectedOption: (option: CustomPopoverItemProps) => void;
    triggerVariant?: "icon" | "button";
    triggerLabel?: string;
    fullWidth?: boolean;
}

export interface CustomPopoverItemProps {
    label: string;
    id: string;
    active: boolean;
}

export const CustomPopover: FC<
    React.PropsWithChildren<CustomPopoverProps>
> = ({
    options,
    selectedOption,
    setSelectedOption,
    openPopOverLabel,
    triggerVariant = "icon",
    triggerLabel,
    fullWidth = false,
}) => {

        const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

        const openPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const closePopover = () => {
            setAnchorEl(null);
        };

        const open = Boolean(anchorEl);
        const id = open ? 'simple-popover' : undefined;

        const selectOption = (option: CustomPopoverItemProps) => {
            setSelectedOption(option);
            closePopover();
        }

        const createOptions = () => {
            return options.map((option: CustomPopoverItemProps) => {
                return (
                    <Button
                        disabled={itemDisabled(option)}
                        onClick={() => selectOption(option)}
                        sx={{
                            justifyContent: "flex-start",
                        }}
                        id={option.id}
                        key={option.id}>
                        {option.label}
                    </Button >
                );
            });
        }

        const itemDisabled = (option: CustomPopoverItemProps) => {
            if (!option.active) {
                return true;
            }

            return selectedOption == option.id;
        }

        return (
            <>
                {triggerVariant === "button" ? (
                    <Button
                        onClick={openPopover}
                        aria-label={openPopOverLabel}
                        endIcon={<KeyboardArrowUpIcon />}
                        sx={{
                            width: fullWidth ? "100%" : "auto",
                            justifyContent: "space-between",
                            fontWeight: 600,
                            textTransform: "none",
                        }}
                    >
                        {triggerLabel ?? openPopOverLabel}
                    </Button>
                ) : (
                    <IconButton onClick={openPopover} aria-label={openPopOverLabel}>
                        <KeyboardArrowUpIcon />
                    </IconButton>
                )}
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={closePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}>
                    <Stack direction="column">
                        {createOptions()}
                    </Stack>
                </Popover>
            </>
        );
    };

export default CustomPopover;